// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15cYr","buttons":"styles_buttons__2AZFm"};